define((require) => {
    "use strict";

    var _          = require("underscore"),
        Marionette = require("marionette"),
        template   = require("ui/common/tip/Tip.tpl");

    /**
     * View class showing a "Did you know?" tip.
     *
     * @class Tip
     * @constructor
     *
     * @cfg {String|Function} content The content to display in the tip. May either be plain HTML or a template.
     * @cfg {Object} [templateData] If content is a template, this data will be passed to it when it is rendered.
     */
    return Marionette.ItemView.extend({

        className: "tip",
        template: template,
        ui: {
            icon: ".tip-icon",
            content: ".tip-content"
        },
        events: {
            "click .tip-close": "close"
        },
        onRender: function() {
            // Disabled for now, as a question mark doesn't really make sense with the current wording.
            // this.ui.icon.append(Icons.QUESTION_MARK.createElement());

            if (_.isFunction(this.options.content)) {
                this.ui.content.html(this.options.content(this.options.templateData || {}));
            } else {
                this.ui.content.html(this.options.content);
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/common/tip/Tip.js